/**
 * Helpers for presenting payout timesheet review status metadata.
 */

/**
 * Returns banner display metadata for a payout review status response.
 *
 * @param {Object|null|undefined} reviewStatus - Backend review status metadata.
 * @returns {{show: boolean, variant: string, message: string}} Banner display props.
 */
export function getPayoutReviewBanner(reviewStatus) {
  if (!reviewStatus || reviewStatus.reviewMode === "pending") {
    return {
      show: false,
      variant: "warning",
      message: "",
    };
  }

  return {
    show: Boolean(reviewStatus.bannerMessage),
    variant: reviewStatus.bannerVariant === "error" ? "error" : "warning",
    message: reviewStatus.bannerMessage || "",
  };
}

/**
 * Returns whether a payout review is opening an already signed timesheet.
 *
 * @param {Object|null|undefined} reviewStatus - Backend review status metadata.
 * @returns {boolean} Whether the sheet is being reopened.
 */
export function isReopenedPayoutReview(reviewStatus) {
  return Boolean(reviewStatus && reviewStatus.reviewMode !== "pending");
}
